module.exports = __webpack_public_path__ + "img/icon_sxdw_select.720a474d.png";